import { AxiosError } from 'axios';

import { axiosMeedioClient } from './client';
import { MeetingResponse } from './types';

export const getMeetingByAlias = async (alias: string): Promise<MeetingResponse | null> => {
  try {
    const { data } = await axiosMeedioClient.get<MeetingResponse>(`/room/alias/${alias}`);
    return data;
  } catch (error) {
    if (error instanceof AxiosError) {
      const status = error.response?.status;
      if (status === 404 || status === 403) return null;
    }
    throw error;
  }
};
